import { type RefObject, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';

/**
 * Hook that scrolls to top when location changes
 * @param scrollContainerRef Ref to the scrollable container element
 */
export const useScrollToTopOnLocationChange = (
  scrollContainerRef: RefObject<HTMLElement>
): void => {
  const location = useLocation();

  useLayoutEffect(() => {
    if (scrollContainerRef.current && typeof scrollContainerRef.current.scrollTo === 'function') {
      scrollContainerRef.current.scrollTo(0, 0);
    }
  }, [location.pathname, scrollContainerRef]);
};
